import React, {Component} from 'react';
import {connect} from 'react-redux';
import {reduxForm, getFormSubmitErrors} from 'redux-form';
import {Form, Card, Button, Grid, Popup, Icon, Loader} from 'semantic-ui-react';
import {numbersDictionary} from '../../../../../../common/dictionaries/classification';
import {hasAccessPermission} from '../../../../../../common/permissions/validations';
import {resources, scopes} from '../../../../../../common/permissions/dictionary';
import {colorsCategories} from '../../../../../../common/constants/colors';
import {ICC_CATEGORIES_PARAMETERS} from '../../../../../../common/forms';
import {paths} from '../../../../../../common/dictionaries/urls';
import {Actions} from '../../../../../../common/actions';
import ItemRow from './itemRow';

const categories = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'J', 'K'];

class IccParametersForm extends Component {
  componentDidMount() {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.IccMatrixParameters,
        scopes.See
      ) &&
      !hasAccessPermission(
        this.props.permissions,
        resources.IccMatrixParameters,
        scopes.Edit
      )
    ) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.props.fetchIccParameters();
  }

  cancelClick() {
    this.props.navigateTo(paths.IccMatrix);
  }

  renderSaveButton() {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.IccMatrixParameters,
        scopes.Edit
      )
    ) {
      return null;
    }

    const {loading, submitting} = this.props;
    return (
      <Button
        primary
        type='submit'
        className='toyota-primary'
        disabled={submitting || loading}
      >
        Guardar
      </Button>
    );
  }

  renderCategoriesItems() {
    const {submitErrors} = this.props;
    return categories.map((letter, index) => {
      return (
        <ItemRow
          key={index}
          title={letter}
          name={letter.toLowerCase()}
          category={index < 5 ? 'WAD' : 'MSM'}
          className={colorsCategories[index] || 'manatee'}
          submitErrors={submitErrors}
        />
      );
    });
  }

  renderSubCategoriesItems() {
    const {submitErrors} = this.props;
    return Object.entries(numbersDictionary).map(
      ([number, numberName], index) => {
        return (
          <ItemRow
            key={index}
            title={number}
            name={numberName.toLowerCase()}
            category='Fluc Dem'
            className={colorsCategories[index]}
            submitErrors={submitErrors}
          />
        );
      }
    );
  }

  renderData() {
    return (
      <Grid columns={2}>
        <Grid.Row>
          <Grid.Column>
            <Card raised fluid>
              <div className='title-bar'>
                <div className='title'>
                  <h3>Categorías - Demanda</h3>
                </div>
              </div>
              <Grid textAlign='center' className='categories'>
                <Grid.Row columns={3}>
                  <Grid.Column width={4} textAlign='right'>
                    Valores Mínimos
                  </Grid.Column>
                  <Grid.Column width={7}></Grid.Column>
                  <Grid.Column width={4} textAlign='right'>
                    Valores Máximos
                  </Grid.Column>
                </Grid.Row>
                {this.renderCategoriesItems()}
              </Grid>
              <div className='category-information'>
                <div className='category-information-text'>
                  WAD (Weekly Average Demand)
                </div>
                <div className='category-information-text'>
                  MSM (Meses Sin Movimiento)
                </div>
              </div>
            </Card>
          </Grid.Column>
          <Grid.Column>
            <Card raised fluid>
              <div className='title-bar'>
                <div className='title'>
                  <h3>Categorías - Fluctuación</h3>
                  <div className='title-bar-actions'>
                    <Popup
                      trigger={
                        <Icon link name='info circle' color='blue' size='big' />
                      }
                      on='click'
                      position='bottom left'
                      inverted
                    >
                      <div>
                        Fórmula utilizada: Fluctuación = ((((DemMayor -
                        DemMenor) / WAD) * 52) / 12)
                      </div>
                    </Popup>
                  </div>
                </div>
              </div>
              <Grid textAlign='center' className='subcategories'>
                <Grid.Row columns={3}>
                  <Grid.Column width={4} textAlign='right'>
                    Valores Mínimos
                  </Grid.Column>
                  <Grid.Column width={7}></Grid.Column>
                  <Grid.Column width={4} textAlign='right'>
                    Valores Máximos
                  </Grid.Column>
                </Grid.Row>
                {this.renderSubCategoriesItems()}
              </Grid>
            </Card>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }

  renderLoaderOrData() {
    const {loading} = this.props;
    if (loading) {
      return (
        <Card raised fluid>
          <Loader active inline='centered' />
        </Card>
      );
    }
    return this.renderData();
  }

  render() {
    const {handleSubmit, submitting} = this.props;

    return (
      <Form className='icc-form' onSubmit={handleSubmit} loading={submitting}>
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <h2>ICC - Inventory Class Control</h2>
              <div className='title-bar-actions'>
                <Button
                  type='button'
                  secondary
                  className='toyota-secondary'
                  disabled={submitting}
                  onClick={() => this.cancelClick()}
                >
                  Cancelar
                </Button>
                {this.renderSaveButton()}
              </div>
            </div>
          </div>
        </Card>
        {this.renderLoaderOrData()}
      </Form>
    );
  }
}

export {IccParametersForm};

const form = reduxForm({
  'form': ICC_CATEGORIES_PARAMETERS.name,
  'initialValues': ICC_CATEGORIES_PARAMETERS.initialValues,
})(IccParametersForm);

const mapStateToProps = (state, ownProps) => {
  return {
    'loading': state.iccmatrix.loading,
    'submitErrors': getFormSubmitErrors('iccCategoriesParameters')(state),
    'menuSelected': state.menu.selected,
    'permissions': state.session.permissions,
  };
};

const {fetchIccParameters, navigateTo} = Actions;

export default connect(mapStateToProps, {
  fetchIccParameters,
  getFormSubmitErrors,
  navigateTo,
})(form);
